import React from "react";
import { useLocation } from "react-router-dom";
import NodeWrapper from "../shared-components/node-wrapper";
import useNodeQuery from "@default/hooks/use-node-query";
import newsPageQuery from "./news.graphql";
import ContentBase from "@default/general-components/content-base/content-base";
import FieldTime from "@default/general-components/date-time/field-time";
import Image from "../../general-components/image/image";
import Hyphenated from "react-hyphen";
import de from "hyphenated-de";
import classNames from "classnames";
import useAccessibilityContext from "../../accessibility/store/use-accessibility-context";
import OpenGraphMeta from "@default/js/general-components/seo/open-graph-meta";
import { self } from "@default/js/config";

const News = () => {
  const { entity, loading, error } = useNodeQuery(newsPageQuery);
  const { simpleDesign } = useAccessibilityContext();
  const { pathname } = useLocation();

  return (
    <NodeWrapper entity={entity} loading={loading} error={error}>
      {entity && (
        <>
          <OpenGraphMeta
            title={entity.label}
            type="article"
            url={self + pathname}
            image={entity.fieldImage?.fieldMediaImage?.style?.url
              ? { url: entity.fieldImage.fieldMediaImage.style.url, alt: entity.fieldImage.fieldMediaImage.alt }
              : undefined}
            articleMeta={{
              publishedTime: entity.publishedAt,
              section: entity.fieldSponsored ? 'Sponsored News' : 'News',
              tags: entity.fieldTags?.map(t => t.name),
            }}
          />
          <div className="container news">
          <div className="row">
            <div
               className={classNames({
                 "col-12 image-col": true,
                 "col-md-6": !simpleDesign,
                 "col-lg-9 offset-lg-2": simpleDesign
               })}
            >
              {entity?.fieldImage && (
                <Image
                  data={entity.fieldImage.fieldMediaImage}
                  nodeTitle={entity.title}
                  credit={entity.fieldImage.fieldCredits}
                />
              )}
            </div>
            <div
              className={classNames({
                "col-12 content-col": true,
                "col-md-5 offset-md-1": !simpleDesign,
                "col-lg-9 offset-lg-2": simpleDesign
              })}
            >
              <div className="meta">
                {entity?.publishedAt && (
                  <div className="published-on">
                    <FieldTime
                      timestamp={false}
                      date={entity?.publishedAt}
                      format={"D MMMM"}
                    />
                  </div>
                )}
                {entity.fieldSponsored && <span> Sponsored News</span>}
              </div>

              {entity.label && (
                <Hyphenated language={de}>
                  <h1>{entity.label}</h1>
                </Hyphenated>
              )}

              {entity?.fieldModules && (
                <ContentBase
                  content={entity.fieldModules.list}
                  viewMode={"news"}
                />
              )}
            </div>
          </div>
        </div>
        </>
      )}
    </NodeWrapper>
  );
};

News.propTypes = {};

export default News;
